import logo from "../assets/techtcl-1.svg";
import email_icon from "../assets/email.png";
import phonecall from "../assets/phone-call.png";
// import CTAModel from "../assets/CTA-models.png";
import "../styles/Footer.css";
import WhiteArrow from "../assets/white-arrow.png";

import { Link } from "react-router-dom";
import { FiFacebook } from "react-icons/fi";
import {
  FaInstagram,
  FaLinkedinIn,
  FaRedditAlien,
  FaWhatsapp,
  FaTiktok,
} from "react-icons/fa";
import { FaThreads, FaXTwitter } from "react-icons/fa6";
export default function Footer() {
  const handleNewsletter = (event) => {
    event.preventDefault();
    // console.log("Newsletter submitted");
  };

  return (
    <footer className="footer">
      <div className="ttcl-cta-wrapper">
        <div className="dotted-bg"></div>
        <div className="ttcl-cta-banner">
          {/* Left side woman image */}
          <div className="ttcl-cta-left-image">
            <img
              src="https://cdn.shopify.com/s/files/1/0644/4086/0781/files/CTA-models.png?v=1765273635"
              alt="Professional consultant pointing"
            />
          </div>

          {/* Right side background image (behind button) */}
          <div className="ttcl-cta-right-bg-image">
            <img
              src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=500&h=400&fit=crop"
              alt="Business meeting background"
            />
          </div>

          {/* Center content */}
          <div className="ttcl-cta-content">
            <h2 className="ttcl-cta-heading">
              Ready to build a Shopify store
              <br />
              that actually converts?
            </h2>
            <div className="ttcl-cta-arrow">
              <img
                src="https://cdn.shopify.com/s/files/1/0644/4086/0781/files/white-arrow.png?v=1765273818"
                alt="Arrow pointing right"
              />
            </div>
          </div>

          {/* CTA Button */}
          <div className="ttcl-cta-button-wrapper">
            <Link to="/contact" className="ttcl-cta-button">
              Book Your Session
            </Link>
          </div>
        </div>
      </div>
      <div className="footer-container">
        <div className="footer-main">
          <div className="footer-brand">
            <div className="footer-logo">
              <div className="logo">
                <Link to="/">
                  <img loading="lazy" src={logo} alt="logo" />
                </Link>
              </div>
            </div>
            <div className="company_info">
              <p>
                We create exceptional digital experiences that drive growth and
                innovation.Transforming ideas into powerful solutions since
                2020.
              </p>
            </div>
          </div>

          <div className="footer-menu">
            <div>
              <h4>Services</h4>
              <ul>
                <li>
                  <Link to="/services/complete-shopify-store-setup">
                    Complete Shopify Store
                  </Link>
                </li>
                <li>
                  <Link to="/services/shopify-brand-redesign-refresh">
                    Website Redesign
                  </Link>
                </li>
                <li>
                  <Link to="/services/professional-dropshipping-website">
                    Automated Dropshipping
                  </Link>
                </li>
                <li>
                  <Link to="/services/seamless-sales-funnel-integration">
                    Funnel Integration
                  </Link>
                </li>
                <li>
                  <Link to="/services/pixel-perfect-figma-to-shopify-conversion">
                    Figma to Shopify
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4>Company</h4>
              <ul>
                <li>
                  <Link to="/about">About Us</Link>
                </li>
                {/* <li>
                  <Link to="/portfolio">Portfolio</Link>
                </li> */}
                <li>
                  <Link to="/careers">Careers</Link>
                </li>
                <li>
                  <Link to="/how-we-work">How We Work</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </div>
            <div>
              <h4>Resources</h4>
              <ul>
                <li>
                  <Link to="/compare">TechTCL vs Others</Link>
                </li>
                <li>
                  <Link to="/roi-calculator">ROI Calculator</Link>
                </li>
                <li>
                  <Link to="/our-process">Our Process</Link>
                </li>
                <li>
                  <Link to="/blogs">Blog</Link>
                </li>
                <li>
                  <Link to="/speed-test">Speed Test Tool</Link>
                </li>
                <li>
                  <Link to="/shopify-for-beauty-brands">Shopify for Beauty</Link>
                </li>
                <li>
                  <Link to="/shopify-for-fashion-brands">Shopify for Fashion</Link>
                </li>
              </ul>
            </div>
            <div>
              <h4>Contact us</h4>
              <div className="address_contact_wrap">
                <p>House#31, Lane #3, Block-B, Mirpur-11, Dhaka Bangladesh</p>
                <div className="icon_wrapper">
                  <img loading="lazy" src={email_icon} className="email_icon" alt="Email" width={20} height={20} />{" "}
                  <p>support@techtcl.com</p>
                </div>
                <div className="icon_wrapper">
                  <img loading="lazy" src={phonecall} className="email_icon" alt="Phone" width={20} height={20} />{" "}
                  <p>(+880)1837-127779</p>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-newsletter">
            <h4>Stay Updated</h4>
            <p>
              Subscribe to our newsletter for the latest insights and updates.
            </p>
            <form
              className="newsletter-form"
              onSubmit={(event) => handleNewsletter(event)}
            >
              <input
                type="email"
                className="newsletter-input"
                placeholder="Enter your email address"
                required
              />
              <button type="submit" className="newsletter-btn">
                Subscribe
              </button>
            </form>
            <h4>Follow Us</h4>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              <Link
                to="https://www.facebook.com/profile.php?id=61578997427316"
                target="_blank"
                style={{ width: 42, height: 42, borderRadius: 10, background: "#1877F2", display: "flex", alignItems: "center", justifyContent: "center", transition: "all .3s", textDecoration: "none" }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </Link>
              <Link
                to="https://wa.link/tlqp49"
                target="_blank"
                style={{ width: 42, height: 42, borderRadius: 10, background: "#25D366", display: "flex", alignItems: "center", justifyContent: "center", transition: "all .3s", textDecoration: "none" }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
              </Link>
              <Link
                to="https://www.linkedin.com/company/techtcl/"
                target="_blank"
                style={{ width: 42, height: 42, borderRadius: 10, background: "#0A66C2", display: "flex", alignItems: "center", justifyContent: "center", transition: "all .3s", textDecoration: "none" }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
              </Link>
              <Link
                to="https://www.tiktok.com/@techtcl"
                target="_blank"
                style={{ width: 42, height: 42, borderRadius: 10, background: "#000", display: "flex", alignItems: "center", justifyContent: "center", transition: "all .3s", textDecoration: "none" }}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="#fff"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg>
              </Link>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; 2026 Techtcl.com All rights reserved. |
            <Link to="/privacy-policy">Privacy Policy</Link> |
            <Link to="/terms-conditions">Terms & Conditions</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
